(function () {
  'use strict';
  var QT = window.PETIDI_T || {};

  function updateCartCount() {
    fetch((window.PETIDI_KOK || '') + '/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      // Mobil (#CartCount) + masaüstü sepet rozeti (13 Eki 2026)
      document.querySelectorAll('#CartCount, [data-cart-count]').forEach(function (badge) {
        badge.textContent = c.item_count;
        badge.style.display = c.item_count > 0 ? '' : 'none';
      });
    }).catch(function () {});
  }
  // Diğer scriptlerin (product.js) de kullanabilmesi için global olarak yayınla
  window.petidiUpdateCartCount = updateCartCount;

  // İl → teslim süresi (iş günü) tablosu: ürün sayfası (product.js) ile kart/sepet AYNI tabloyu kullanır (24 Eki 2026: ürün
  // sayfası "Salı", kart "Çarşamba" diyordu). Kaynak ve yöntem product.js etaYaz notunda / docs/ux-denetim.md #7.
  // window.PETIDI_IL_GUN: theme.liquid <head>'de (product.js bu dosyadan önce çalışıyor).

  // Ürün kartı / sepet satırı teslim günü (card-product.liquid, main-cart.liquid [data-teslim-gun], 13 Eki 2026): kargo çıkış günü
  // + ilin teslim süresi (il bilinmiyorsa 2 iş günü). İl: ziyaretçinin seçtiği (localStorage petidi_il) > IP tahmini
  // (sessionStorage petidi_il_ip, ürün sayfası doldurur). Kural product.js ile aynı: 15:00 kesim (Cmt 12:00), Pazar yok, tema ayarı kargo_tatil (window.PETIDI_TATIL).
  // Ön sipariş (16 Eki 2026): data-onsiparis="N" → kargo bugünden N iş günü sonra (product.js renderShip ile aynı), sonra + 2.
  function teslimGunleri() {
    var els = document.querySelectorAll('[data-teslim-gun]');
    if (!els.length) return;
    var TATIL = {};
    (window.PETIDI_TATIL || []).forEach(function (l) {
      var p = String(l).trim().split(/\s+/);
      if (/^\d{4}-\d{2}-\d{2}$/.test(p[0])) TATIL[p[0]] = p[1] ? parseInt(p[1], 10) || 0 : 0;
    });
    function ymd(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
    function isWork(d) { if (d.getDay() === 0) return false; var t = TATIL[ymd(d)]; return t === undefined || t > 0; }
    function ekle(d, n) { var x = new Date(d), k = 0; while (k < n) { x.setDate(x.getDate() + 1); if (isWork(x)) k++; } return x; }
    var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Istanbul' }));
    var kes = new Date(now), t = TATIL[ymd(now)];
    kes.setHours(t > 0 ? t : (now.getDay() === 6 ? 12 : 15), 0, 0, 0);
    var kargo = new Date(now);
    if (!(isWork(now) && now < kes)) { do { kargo.setDate(kargo.getDate() + 1); } while (!isWork(kargo)); }
    var yarin = new Date(now); yarin.setDate(yarin.getDate() + 1);
    var bugun = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var T = window.PETIDI_T || {};
    var AY = (T.aylar || 'Ocak,Şubat,Mart,Nisan,Mayıs,Haziran,Temmuz,Ağustos,Eylül,Ekim,Kasım,Aralık').split(',');
    var AYK = (T.aylar_kisa || 'Oca,Şub,Mar,Nis,May,Haz,Tem,Ağu,Eyl,Eki,Kas,Ara').split(',');
    var GUNK = (T.gunler_kisa || 'Paz,Pzt,Sal,Çar,Per,Cum,Cmt').split(',');
    var GUNLER = (T.gunler || 'Pazar,Pazartesi,Salı,Çarşamba,Perşembe,Cuma,Cumartesi').split(',');
    function gunYazi(d) {
      if (ymd(d) === ymd(yarin)) return T.yarin_teslim || 'Yarın';
      // Bir haftadan uzaksa gün adı belirsiz ("Cuma" bu hafta mı?) → tarih; kalıp sözlükte (js.eta_tarih: tr "[n] [ay]", en "[gun], [ayk] [n]")
      if ((new Date(d.getFullYear(), d.getMonth(), d.getDate()) - bugun) / 864e5 > 6) return (T.eta_tarih || '[n] [ay]').split('[n]').join(d.getDate()).split('[ayk]').join(AYK[d.getMonth()]).split('[ay]').join(AY[d.getMonth()]).split('[gun]').join(GUNK[d.getDay()]);
      return GUNLER[d.getDay()];
    }
    // İl önceliği ürün sayfasıyla aynı: seçilen > girişli müşterinin varsayılan adresi (theme.liquid PETIDI_MUSTERI_IL) > IP
    var G = window.PETIDI_IL_GUN, il = null, ip = null;
    try { il = localStorage.getItem('petidi_il'); ip = sessionStorage.getItem('petidi_il_ip'); } catch (e) {}
    if (!G[il]) il = G[window.PETIDI_MUSTERI_IL] ? window.PETIDI_MUSTERI_IL : ip;
    if (!G[il] && ip === null && !teslimGunleri.ipSoruldu && window.fetch) {
      teslimGunleri.ipSoruldu = true;   // oturumda bir kez; cevap gelince yeniden yazılır
      fetch('https://ahtapot.petidi.workers.dev/acik/il').then(function (r) { return r.json(); }).then(function (j) {
        var v = j && G[j.il] ? j.il : '';
        try { sessionStorage.setItem('petidi_il_ip', v); } catch (e) {}
        if (v) teslimGunleri();
      }).catch(function () {});
    }
    var sure = G[il] || 2;
    els.forEach(function (el) {
      var n = parseInt(el.getAttribute('data-onsiparis'), 10);
      el.textContent = gunYazi(ekle(n > 0 ? ekle(now, n) : kargo, sure));
    });
  }
  window.petidiTeslimGunleri = teslimGunleri;   // sepet yerinde yenilenince yeni satırlar için (cart.js)

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', teslimGunleri); else teslimGunleri();

  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('qa-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'qa-toast';
      t.className = 'qa-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('is-shown');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-shown'); }, 2600);
  }

  // Overlay (tek örnek, gerektiğinde oluşturulur)
  var overlay;
  function buildOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'qa-overlay';
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="qa-overlay__bg" data-qa-close></div>' +
      '<div class="qa-panel" role="dialog" aria-modal="true">' +
      '<div class="qa-panel__head"><h3 class="qa-panel__title" data-qa-title></h3>' +
      '<button type="button" class="qa-panel__x" data-qa-close aria-label="' + (QT.kapat || 'Kapat') + '">&times;</button></div>' +
      '<p class="qa-panel__sub">' + (QT.qa_sec || 'Lütfen eklemek istediğiniz seçeneği seçin:') + '</p>' +
      '<div class="qa-panel__list" data-qa-list></div></div>';
    document.body.appendChild(overlay);
    overlay.querySelectorAll('[data-qa-close]').forEach(function (b) {
      b.addEventListener('click', closeOverlay);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay && !overlay.hidden) closeOverlay(); });
  }
  function openOverlay() { overlay.hidden = false; document.body.style.overflow = 'hidden'; }
  function closeOverlay() { overlay.hidden = true; document.body.style.overflow = ''; }

  function addToCart(id, btn, label) {
    if (btn) btn.disabled = true;
    fetch((window.PETIDI_KOK || '') + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error();
      updateCartCount();
      if (overlay && !overlay.hidden) closeOverlay();
      toast((QT.qa_eklendi || '[urun] sepete eklendi ✓').replace('[urun]', label || QT.urun || 'Ürün'));
      // Sepet sayfasındaki "Sepetine yakışanlar" kartından eklendiyse sepet listesi yenilensin
      if (document.querySelector('.cart [data-gift-plan]')) document.dispatchEvent(new CustomEvent('petidi:sepet'));
    }).catch(function () {
      toast(QT.qa_hata || 'Ürün eklenemedi, lütfen tekrar deneyin.');
    }).then(function () { if (btn) btn.disabled = false; });
  }

  // Kart üzerinde varyant seçimi
  document.addEventListener('click', function (e) {
    var v = e.target.closest('[data-card-variant]');
    if (!v || v.classList.contains('is-out')) return;
    var wrap = v.closest('.pcard__variants');
    if (!wrap) return;
    wrap.querySelectorAll('[data-card-variant]').forEach(function (x) {
      x.classList.toggle('is-selected', x === v);
      x.setAttribute('aria-pressed', x === v ? 'true' : 'false');
    });
    // Seçili boyun fiyatı, eski fiyatı ve düzenli teslimat fiyatı (card-product.liquid data-*; 13 Eki 2026)
    var card = v.closest('.pcard');
    if (!card) return;
    var pr = card.querySelector('[data-card-price]');
    var old = card.querySelector('[data-card-old]');
    var dt = card.querySelector('[data-card-dt]');
    if (pr && v.dataset.price) pr.textContent = v.dataset.price;
    if (old) { old.textContent = v.dataset.old || ''; old.hidden = !v.dataset.old; }
    if (dt && v.dataset.dt) dt.textContent = v.dataset.dt;
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-add]');
    if (!trigger) return;
    e.preventDefault();
    var variants;
    try { variants = JSON.parse(trigger.getAttribute('data-variants')); } catch (err) { return; }
    var title = trigger.getAttribute('data-title') || QT.urun || 'Ürün';
    var avail = variants.filter(function (v) { return v.available; });
    if (avail.length === 0) return;
    // Kartta seçili varyant varsa doğrudan onu ekle
    var card = trigger.closest('.pcard');
    var sel = card && card.querySelector('[data-card-variant].is-selected');
    if (sel) { addToCart(parseInt(sel.getAttribute('data-variant-id'), 10), trigger, title); return; }
    if (avail.length === 1) { addToCart(avail[0].id, trigger, title); return; }

    // Çok varyantlı: overlay aç
    if (!overlay) buildOverlay();
    overlay.querySelector('[data-qa-title]').textContent = title;
    var list = overlay.querySelector('[data-qa-list]');
    list.innerHTML = '';
    variants.forEach(function (v) {
      var row = document.createElement('div');
      row.className = 'qa-row';
      var info = document.createElement('div');
      info.className = 'qa-row__info';
      info.innerHTML = '<span class="qa-row__title"></span><span class="qa-row__price"></span>';
      info.querySelector('.qa-row__title').textContent = v.title;
      info.querySelector('.qa-row__price').textContent = v.price;
      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'qa-row__add';
      if (v.available) {
        add.textContent = QT.ekle || 'Ekle';
        add.addEventListener('click', function () { addToCart(v.id, add, title); });
      } else { add.textContent = QT.tukendi || 'Tükendi'; add.disabled = true; }
      row.appendChild(info); row.appendChild(add);
      list.appendChild(row);
    });
    openOverlay();
  });

  // Kart görsel galerisi (card-product.liquid [data-pcard-slides], 13 Eki 2026). Olaylar belgeye bağlı: sonsuz kaydırmayla
  // gelen kartlar da çalışır. 2.+ fotoğraflar ilk üzerine gelişte / dokunuşta yüklenir.
  function pcardYukle(track) {
    if (!track || track.dataset.yuklendi) return;
    track.dataset.yuklendi = '1';
    track.querySelectorAll('img[data-src]').forEach(function (im) {
      im.srcset = im.dataset.srcset; im.src = im.dataset.src;
      im.removeAttribute('data-src'); im.removeAttribute('data-srcset');
    });
  }
  function pcardTrack(el) {
    var media = el && el.closest && el.closest('.pcard__media');
    return media && media.querySelector('[data-pcard-slides]');
  }
  document.addEventListener('pointerover', function (e) { pcardYukle(pcardTrack(e.target)); });
  document.addEventListener('touchstart', function (e) { pcardYukle(pcardTrack(e.target)); }, { passive: true });
  document.addEventListener('click', function (e) {
    var ok = e.target.closest && e.target.closest('[data-pcard-ok]');
    if (!ok) return;
    e.preventDefault();
    var t = pcardTrack(ok); if (!t) return;
    pcardYukle(t);
    var w = t.clientWidth, n = t.children.length;
    var i = Math.round(t.scrollLeft / w) + parseInt(ok.getAttribute('data-pcard-ok'), 10);
    if (i < 0) i = n - 1; else if (i >= n) i = 0;
    t.scrollTo({ left: i * w, behavior: 'smooth' });
  });
  // scroll olayı kabarcıklanmaz → yakalama aşamasında dinle
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-pcard-slides')) return;
    pcardYukle(t);
    var i = Math.round(t.scrollLeft / t.clientWidth);
    var dots = t.parentNode.querySelectorAll('.pcard__dots i');
    dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
  }, true);
})();
